import { jsx as z } from "react/jsx-runtime";
import { c as F } from "react/compiler-runtime";
import { useTheme as H, Typography as W } from "@mui/material";
import { forwardRef as d } from "react";
const x = {
  statistics1: {
    variant: "statistics1",
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: "2rem",
    fontFamily: "Satoshi"
  },
  statistics2: {
    variant: "statistics2",
    fontWeight: 700,
    fontSize: "0.875rem",
    lineHeight: "1.0625rem",
    fontFamily: "Satoshi"
  },
  heading1: {
    variant: "h1",
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: "1.1875rem",
    fontFamily: "'Inter', sans-serif"
  },
  heading2: {
    variant: "h2",
    fontWeight: 500,
    fontSize: "1rem",
    lineHeight: "1.1875rem",
    fontFamily: "'Inter', sans-serif"
  },
  heading3: {
    variant: "h3",
    fontWeight: 600,
    fontSize: "0.875rem",
    lineHeight: "1.0625rem",
    fontFamily: "'Inter', sans-serif"
  },
  heading4: {
    variant: "h4",
    fontWeight: 500,
    fontSize: "0.875rem",
    lineHeight: "1.0625rem",
    fontFamily: "'Inter', sans-serif"
  },
  heading5: {
    variant: "h5",
    fontWeight: 400,
    fontSize: "0.875rem",
    lineHeight: "1.0625rem",
    fontFamily: "'Inter', sans-serif"
  },
  bodyText1: {
    variant: "subtitle1",
    fontWeight: 600,
    fontSize: "0.75rem",
    lineHeight: "0.9375rem",
    fontFamily: "'Inter', sans-serif"
  },
  bodyText2: {
    variant: "subtitle2",
    fontWeight: 500,
    fontSize: "0.75rem",
    lineHeight: "0.9375rem",
    fontFamily: "'Inter', sans-serif"
  },
  bodyText3: {
    variant: "body1",
    fontWeight: 400,
    fontSize: "0.75rem",
    lineHeight: "0.9375rem",
    fontFamily: "'Inter', sans-serif"
  },
  smallText: {
    variant: "caption",
    fontWeight: 400,
    fontSize: "0.625rem",
    lineHeight: "0.75rem",
    fontFamily: "'Inter', sans-serif"
  }
}, C = d((y, c) => {
  const t = F(26), s = H();
  let n, i, o, a, r, l;
  t[0] !== y ? ({
    children: n,
    type: l,
    color: i,
    sx: r,
    style: a,
    ...o
  } = y, t[0] = y, t[1] = n, t[2] = i, t[3] = o, t[4] = a, t[5] = r, t[6] = l) : (n = t[1], i = t[2], o = t[3], a = t[4], r = t[5], l = t[6]);
  const v = l === void 0 ? "bodyText3" : l;
  let h;
  t[7] !== i || t[8] !== s ? (h = typeof i == "function" ? i(s) : i ?? s.vars?.palette.grey["900"] ?? s.palette.grey[900], t[7] = i, t[8] = s, t[9] = h) : h = t[9];
  const p = h, e = x[v];
  let m;
  t[10] !== e.fontFamily || t[11] !== e.fontSize || t[12] !== e.fontWeight || t[13] !== e.lineHeight ? (m = {
    fontWeight: e.fontWeight,
    fontSize: e.fontSize,
    lineHeight: e.lineHeight,
    fontFamily: e.fontFamily,
    letterSpacing: "unset"
  }, t[10] = e.fontFamily, t[11] = e.fontSize, t[12] = e.fontWeight, t[13] = e.lineHeight, t[14] = m) : m = t[14];
  const S = m;
  let f;
  t[15] !== S || t[16] !== p || t[17] !== r ? (f = {
    ...S,
    color: p,
    ...r
  }, t[15] = S, t[16] = p, t[17] = r, t[18] = f) : f = t[18];
  let g;
  return t[19] !== n || t[20] !== o || t[21] !== c || t[22] !== a || t[23] !== f || t[24] !== e.variant ? (g = /* @__PURE__ */ z(W, { variant: e.variant, sx: f, style: a, ref: c, ...o, children: n }), t[19] = n, t[20] = o, t[21] = c, t[22] = a, t[23] = f, t[24] = e.variant, t[25] = g) : g = t[25], g;
});
export {
  C as Typography
};
